import { useSuspenseQuery } from "@tanstack/react-query";
import { Flex, OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "@wayflyer/undercarriage";

import { IncompleteStepsModal } from "../../../components/incomplete-steps-modal";

import { getCustomerBusinessModelQueryOptions } from "../../../queries/customer-data/queries";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import { getAccountingThreshold } from "../../../utils/funding-journey";
import { ManagementAccountDocumentUpload, useDocumentNavigationActions, MESSAGES } from "../components";

export const ManagementAccountsDocumentUploadPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: businessModel } = useSuspenseQuery(getCustomerBusinessModelQueryOptions(customerDomain));
  const { data: fundingApplicationData } = useFundingApplication(customerDomain);

  const { primaryAction, secondaryAction, applicationSubmit, documentError } = useDocumentNavigationActions({
    forType: UploadDocumentType.MANAGEMENT_ACCOUNTS,
  });

  const requiredDuration =
    fundingApplicationData.requestedAmount &&
    fundingApplicationData.requestedAmountCurrency &&
    fundingApplicationData.requestedAmount >=
      4 * getAccountingThreshold(businessModel)[fundingApplicationData.requestedAmountCurrency]
      ? 24
      : 12;

  return (
    <>
      <IncompleteStepsModal {...applicationSubmit} />
      <OnboardingLayout
        variant="wide"
        title={intl.formatMessage(MESSAGES.managementAccountsTitle)}
        actions={{ primary: primaryAction, secondary: secondaryAction }}
      >
        <Flex maxWidth="550px">
          <ManagementAccountDocumentUpload duration={requiredDuration} error={documentError} />
        </Flex>
      </OnboardingLayout>
    </>
  );
};
